import { GeneralShape } from '../../general/general-shape';
import {
  CommentShapeDescriptor,
  ShapeConfig,
} from '../../../../../elements/resource/types/shape.type';
import { ResourceData } from '../../../../../elements/resource/resource.types';
import { ShapeService } from '../../../shape.service';
import { RectangleController } from '../../../../../elements/util/rectangle-controller/rectangle-controller';
import { ImageElement } from '../../primitive/image-element';

export class CommentShape extends GeneralShape<CommentShapeDescriptor> {
  get comments() {
    return this.descriptor?.comments || [];
  }
  baseImageScale = 0.7;

  constructor(
    cs: ShapeService,
    data: ResourceData<CommentShapeDescriptor>,
    config: ShapeConfig,
  ) {
    super(cs, data, config);
    this.init();
    this.redraw();
  }

  init() {
    super.init();

    if (this.config?.isRoot) {
      this.rc = new RectangleController(
        this,
        {
          noFill: true,
          width: this.baseImageScale * 42,
          height: this.baseImageScale * 42,
          drag: () => {},
          endDrag: () => {},
          skipPCs: true,
        },
        this.container,
        this.auxCircleContainer,
      );
      this.rc.hide();

      const imageElement = new ImageElement(this, this.container, {
        src: 'assets/icons/comment-icon.png',
        x: 0,
        y: 0,
        width: this.baseImageScale,
        height: this.baseImageScale,
      })
        .mouseover(() => {
          this.rc.show();
        })
        .mouseout(() => {
          this.rc.hide();
        })
        .click(() => {
          this.clicked();
        });
      imageElement.drag(
        (dx, dy) => {
          this.service.drag(dx, dy);
        },
        () => {
          this.localStartDrag();
        },
        () => {
          this.service.endDrag();
        },
      );

      // imageElement.element.cursor = 'pointer';
      // imageElement.element.eventMode = 'dynamic';
      // imageElement.element.on('pointerdown', () => {
      //   this.cs.draggedSVGElement = imageElement;
      //   throw new Error('imageeelement');
      // });
    }
  }

  zoomUpdate() {
    console.log('- comment-shape > zoomUpdate -');
  }
}
